import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { resolver } from '../utils';

const defaultValues = {
  workingSectorId: '',
  workingActivityId: '',
};

export const useWorkFormModalForm = ({
  user,
  updateUserMutation,
}) => {
  const {
    reset,
    watch,
    control,
    setValue,
    formState,
    handleSubmit,
    getFieldState,
  } = useForm({
    resolver,
    defaultValues,
  });

  const workingSectorIdValue = watch('workingSectorId');
  const { isDirty: isWorkingSectorIdTouched } = getFieldState('workingSectorId', formState);

  const submitHandler = (values) => {
    updateUserMutation({
      variables: {
        userInput: {
          profile: {
            workingSectorId: values.workingSectorId,
            workingActivityId: values.workingActivityId,
          },
        },
      },
    });
  };

  const onSubmit = handleSubmit(submitHandler);

  useEffect(() => {
    if (!isWorkingSectorIdTouched) return;
    setValue('workingActivityId', '');
  }, [setValue, isWorkingSectorIdTouched]);

  useEffect(() => {
    if (!user) return;
    reset({
      workingSectorId: user.workingSector?.id || '',
      workingActivityId: user.workingActivity?.id || '',
    });
  }, [reset, user]);

  return {
    control,
    onSubmit,
    workingSectorIdValue,
  };
};
